import { RouteConfigProvider } from '@/context/route-config';
import AmlQuestionnaireForm, { type AmlQuestionnaireRouteConfig } from '@/features/onboarding/aml-questionnaire/components/form';
import AmlQuestionnaireLayout from '@/features/onboarding/aml-questionnaire/layout';

const ROUTE_CONFIG = {
  next: '/onboarding/complete',
  personalInformation: '/onboarding/personal-information',
} satisfies AmlQuestionnaireRouteConfig;

const AmlQuestionnairePage = () => {
  return (
    <AmlQuestionnaireLayout>
      <RouteConfigProvider config={ROUTE_CONFIG}>
        <AmlQuestionnaireForm />
      </RouteConfigProvider>
    </AmlQuestionnaireLayout>
  );
};
AmlQuestionnairePage.displayName = 'AmlQuestionnairePage';

export default AmlQuestionnairePage;
